// extracted by mini-css-extract-plugin
export default {"logs":"Console_logs__0xIdJ"};